import { getFooterData } from "@/services/FooterService";
import { useQuery } from "@tanstack/react-query";

function useFooter() {
  return useQuery({
    queryKey: ["footer"],
    queryFn: getFooterData,
    staleTime: 1000 * 60 * 10,
    retry: 2,
    retryDelay: 1000,
  });
}

export default useFooter;
